import { render } from "./change-email-form.vue?vue&type=template&id=0dcfb2cc&scoped=true"
import script from "./change-email-form.vue?vue&type=script&lang=js"
export * from "./change-email-form.vue?vue&type=script&lang=js"

import "./change-email-form.vue?vue&type=style&index=0&id=0dcfb2cc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcfb2cc"]])

export default __exports__